import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";

export const BlogHeader = () => {
  const { t, lang, setLang } = useLang();
  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-white/10 bg-black/60 backdrop-blur-2xl" data-testid="blog-header">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="blog-logo-link">
          <Logo size={32} />
          <span className="font-display font-semibold tracking-tight text-base leading-none">
            Smart <span className="text-[#FF7900]">Telecom</span> Advisor
          </span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white transition-colors duration-300" data-testid="blog-back-link">
            <ArrowLeft className="w-4 h-4" /> {t.blog.back}
          </Link>
          <div className="flex items-center border border-white/15 rounded-full p-1">
            {["fr", "en"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`blog-lang-${l}`}
                className={`px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-widest transition-colors duration-300 ${lang === l ? "bg-[#FF7900] text-white" : "text-white/50 hover:text-white"}`}>
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};
